// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckboxModel_customCheckbox__pXaFZ {
  appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  position: relative;
}

.CheckboxModel_customCheckbox__pXaFZ:checked {
  background-color: #22c55e;
  border-color: #22c55e;
}

.CheckboxModel_customCheckbox__pXaFZ:checked::after {
  content: "";
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  position: absolute;
  top: 2px;
  left: 6px;
  transform: rotate(45deg);
}`, "",{"version":3,"sources":["webpack://./src/components/Common/CustomModel/CheckboxModel/CheckboxModel.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEE;EACE,yBAAA;EACA,qBAAA;AACJ;;AAEE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,wBAAA;AACJ","sourcesContent":[".customCheckbox {\n    appearance: none;\n    width: 20px;\n    height: 20px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: white;\n    cursor: pointer;\n    position: relative;\n  }\n  \n  .customCheckbox:checked {\n    background-color: #22c55e;\n    border-color: #22c55e;\n  }\n  \n  .customCheckbox:checked::after {\n    content: '';\n    width: 6px;\n    height: 12px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    position: absolute;\n    top: 2px;\n    left: 6px;\n    transform: rotate(45deg);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customCheckbox": `CheckboxModel_customCheckbox__pXaFZ`
};
export default ___CSS_LOADER_EXPORT___;
